const options = [
  { id: 1, title: 'My Profile', link: '/profile' },
  { id: 3, title: 'Change Password', link: '/profile/change-password' },
  { id: 4, title: 'FAQs', link: `${process.env.REACT_APP_BASE_URL}/about-boost/faq` },
  { id: 5, title: 'Preferences', link: '/profile/preferences' }
]

export default options
